import React, { ReactNode } from 'react';

import { Box, Paper, Stack, createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  contentPanel: {
    width: '100%',
    height: '100%',
    border: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: theme.radius.md,
    display: 'flex',
    flexDirection: 'column'
  },
  mainContent: {
    flex: 1,
    overflow: 'auto',
    minHeight: 0
  }
}));

interface ContentPanelProps {
  children: ReactNode;
}

export function ContentPanel({ children }: ContentPanelProps) {
  const { classes } = useStyles();

  return (
    <Paper withBorder shadow="sm" radius="md" sx={{ height: '100%', width: '100%' }}>
      <Stack className={classes.contentPanel}>
        <Box className={classes.mainContent}>{children}</Box>
      </Stack>
    </Paper>
  );
}
